import React from "react";

function Footer() {
  return (
    <footer className="mt-20 w-full text-sm leading-loose bg-white max-md:mt-10 max-md:max-w-full">
      {/* <div className="flex flex-wrap gap-10 justify-center items-center p-6 w-full text-gray-700 border-t border-gray-200 max-md:px-5 max-md:max-w-full">
        <a
          href="#"
          className="gap-1 self-stretch pb-0.5 my-auto whitespace-nowrap border-b border-rose-700"
        >
          imprint
        </a>
        <a
          href="#"
          className="gap-1 self-stretch pb-0.5 my-auto whitespace-nowrap border-b border-rose-700"
        >
          Conditions
        </a>
        <a
          href="#"
          className="gap-1 self-stretch pb-0.5 my-auto border-b border-rose-700"
        >
          data protection
        </a>
      </div> */}
      <div className="gap-2 self-stretch px-2 py-4 w-full text-gray-100 bg-rose-700 max-md:max-w-full">
        © 2025 Ninh Nguyen Huu
      </div>
    </footer>
  );
}

export default Footer;
